import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  uploadBankNameFieldLabel: { id: "funding-application: bank name field label", defaultMessage: "Bank Name" },
  statementsUploadDescription: {
    id: "funding-application: bank statement upload description",
    defaultMessage:
      "If you can’t find your bank on our banking partner’s list, you will need to upload your bank statements to submit your application. If you have multiple banks, connecting a bank account will speed up your application review process. ",
  },
  uploadRequirements: {
    id: "funding-application: bank statement upload requirements",
    defaultMessage: "For this bank, we will need to see:",
  },
  uploadRequirementsPoint1: {
    id: "funding-application: bank statement upload needs point 1",
    defaultMessage: "Bank statements covering the last 6 months, for each account with this bank",
  },
  uploadRequirementsPoint2: {
    id: "funding-application: bank statement upload needs point 2",
    defaultMessage: "The most recent transactions if the latest statement is more than 2 weeks old",
  },
  bankNameRequiredError: {
    id: "funding-application: bank name required error",
    defaultMessage: "Please provide a bank name",
  },
  uploadFileRequiredError: {
    id: "funding-application:  file upload required error",
    defaultMessage: "Please upload at least one file",
  },
  statementUploadDataLoading: {
    id: "funding-application: bank statement upload data loading",
    defaultMessage: "Loading bank statement data, please wait",
  },
  UploadYourBankHeading: {
    id: "funding-application: bank statmenet upload form heading",
    defaultMessage: "Upload your {bankName} statements",
  },
  statementsUploadHeading: {
    id: "funding-application: bank statements upload heading",
    defaultMessage: "Bank Statements",
  },
  previouslyUploadedHeading: {
    id: "funding-application: previously uploaded heading",
    defaultMessage: "Previously uploaded",
  },
});
